const state = {
  paxel_dashboard: [],
};

export default state;
